/**
 * @generated SignedSource<<22f01791939926ca4f11aa6784bb20ac>>
 * @relayHash 93d0e71c0e9655906145a900914785e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d58ee5e92390cf5a10e10fe2f5c3514b43748d5d328d86c05f657306b87e0165

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { IssueLinksPopUpContentQuery } from './IssueLinksPopUpContentQuery.graphql';

const node: PreloadableConcreteRequest<IssueLinksPopUpContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d58ee5e92390cf5a10e10fe2f5c3514b43748d5d328d86c05f657306b87e0165",
    "metadata": {},
    "name": "IssueLinksPopUpContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
